<section id="hero" class="scroll-mt-24">
  <app-hero-about></app-hero-about>
</section>

<section id="about-details" class="scroll-mt-24">
  <app-about-details></app-about-details>
</section>

<section id="vision-mission" class="scroll-mt-24">
  <app-vision-mission></app-vision-mission>
</section>

<section id="why-us" class="scroll-mt-24">
  <app-why-us></app-why-us>
</section>


